import React, {useCallback, useEffect, useState} from 'react'
import {Dialog, Slide, SlideProps} from "@mui/material";
import {useQuery} from "@tanstack/react-query";
import {AxiosError} from "axios";
import HeaderSpacer from "@/view/layout/HeaderSpacer"
import DialogHeader from "@/view/layout/DialogHeader";
import BottomButton from "@/view/common/component/button/BottomButton";
import BoardService, {BoardData} from "@/service/BoardService";
import Board from "@/view/board/Board";
import BoardAdd from "@/view/board/BoardAdd";
import {USER_ID} from "@/common/Constant";
import StorageUtil from "@/common/StorageUtil";

const Transition = React.forwardRef(function Transition(
    props: SlideProps & { children?: React.ReactElement },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="left" ref={ref} {...props} />
})

export interface BoardViewParam{
    onClose : () => void
}

const BoardView = (props:BoardViewParam) => {
    const handleOverlayClick = useCallback(() => props.onClose(), [props.onClose])
    const handleReturnClick = useCallback(() => {handleClose(); initData();}, [props.onClose])
    const handleEditComplete = useCallback(() => {initData();}, [props.onClose])

    const [open, setOpen] = React.useState(false)
    const [regable] = useState(StorageUtil.getLocalStorage(USER_ID) === '1')
    const [boardList, setBoardList] = useState<BoardData[]>([])

    const {refetch:getBoardList} = useQuery<BoardData[], AxiosError>(
        ['getBoardList'],
        ()=> BoardService.getBoardList(),
        {
            onSuccess: (v: BoardData[]) => {console.log(v);setBoardList(v? v: [])},
        }
    )

    const initData = () => {
        getBoardList()
            .then(r => {return Promise<void>})
            .catch(reason => {console.log(reason)})
    }

    useEffect(  () => {
        initData()
    },[])

    useEffect(()=>{
        console.log('변화감지')
    }, [boardList])


    const handleClickOpen = () => {
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
    }

    return (
        <>
            <DialogHeader title='글 목록' onClose={handleOverlayClick}/>
            <div className={'board'}>
                <HeaderSpacer/>
                <Board boardList={boardList} onReturn={handleEditComplete}/>
            </div>
            <BottomButton title='글 등록하기' disabled={!regable} onClick={handleClickOpen}/>
            <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
                {<BoardAdd onClose={handleClose} onReturn={handleReturnClick}/>}
            </Dialog>
        </>
    )
}

export default BoardView;